module.exports = __webpack_public_path__ + "assets/img/img-tutorial05.6483b2cd.png";